/* PopCase: every 5th mobile collection card becomes a featured card.
   Slot 1 (5th product) = A, slot 2 (10th) = B, slot 3 (15th) = C, then A, B, C repeats.
   A = big image + peek of next, B = 5-image filmstrip, C = 3 images.
   Falls back to a layout that fits when a product has too few images. */
(function () {
  if (window.__pcFeat) return;
  window.__pcFeat = true;
  var EVERY = 5;
  var ORDER = ['a', 'b', 'c'];
  var MQ = window.matchMedia('(max-width: 576px)');
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cache = {};

  function esc(s) { return String(s || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }
  function sized(src, w) {
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function infoOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var href = a.getAttribute('href');
    var m = href.match(/\/products\/([^\/?#]+)/);
    return m ? { handle: m[1], url: href } : null;
  }
  function getProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(root + 'products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; });
    }
    return cache[handle];
  }
  function slotOf(card) {
    var pos = Array.prototype.indexOf.call(card.parentNode.children, card) + 1;
    return Math.max(1, Math.round(pos / EVERY));
  }
  function pickLayout(slot, count) {
    var want = ORDER[(slot - 1) % ORDER.length];
    if (want === 'b' && count < 4) want = count >= 3 ? 'c' : 'a';
    if (want === 'c' && count < 3) want = 'a';
    return want;
  }
  function build(card, p, info) {
    var media = (p.media || []).filter(function (m) {
      return m.media_type === 'image' && (m.src || (m.preview_image && m.preview_image.src));
    }).slice(0, 10);
    var box = card.querySelector('.product-card__image');
    var count = media.length;
    if (!box || count < 2) return;
    var layout = pickLayout(slotOf(card), count);
    var first = media[0];
    var ar = first.aspect_ratio || (first.preview_image && first.preview_image.aspect_ratio) || 1;
    var per = layout === 'b' ? 5 : layout === 'c' ? 3 : 1;
    var k = per, positions = count;
    if (layout !== 'a') {
      if (count > per) { k = per === 5 ? 4.5 : 2.6; positions = count - Math.floor(k) + 1; }
      else { k = count; positions = 1; }
    }
    var widths = layout === 'a' ? [450, 720, 1000] : [240, 360, 540];
    var sizes = layout === 'a' ? '88vw' : (layout === 'b' ? '22vw' : '34vw');
    var alt = esc(p.title), url = esc(info.url);
    var html = '<div class="pc-feat-track" data-pc-track style="--pc-ar:' + ar + ';--pc-k:' + k + '">';
    media.forEach(function (m, i) {
      var s = m.src || m.preview_image.src;
      var eager = layout === 'a' ? i === 0 : i < per;
      html += '<a class="pc-feat-slide" draggable="false" href="' + url + '"' + (i ? ' tabindex="-1"' : '') + '>' +
        '<img draggable="false" src="' + sized(s, widths[1]) + '" srcset="' + widths.map(function (w) { return sized(s, w) + ' ' + w + 'w'; }).join(', ') + '"' +
        ' sizes="' + sizes + '" alt="' + alt + '" loading="' + (eager ? 'eager' : 'lazy') + '" decoding="async"></a>';
    });
    html += '</div>';
    if (positions > 1) {
      html += '<div class="pc-feat-dots" aria-hidden="true">';
      for (var d = 0; d < positions; d++) html += '<span class="pc-feat-dot' + (d ? '' : ' is-active') + '"></span>';
      html += '</div>';
    }
    box.innerHTML = html;
    card.classList.add('pc-feat--' + layout);
    card.setAttribute('data-pc-layout', layout);
  }
  function run() {
    if (!MQ.matches) return;
    var cards = document.querySelectorAll('.collection__container > .product-card:nth-child(' + EVERY + 'n):not(.pc-feat-ready)');
    Array.prototype.forEach.call(cards, function (card) {
      var info = infoOf(card);
      card.classList.add('pc-feat-ready');
      if (!info) return;
      getProduct(info.handle).then(function (p) { if (p) build(card, p, info); }).catch(function () {});
    });
  }
  var t;
  function schedule() { clearTimeout(t); t = setTimeout(run, 120); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  if (MQ.addEventListener) MQ.addEventListener('change', run); else if (MQ.addListener) MQ.addListener(run);

  /* ---------- dots ---------- */
  function stepOf(tr) {
    var s = tr.firstElementChild;
    return s ? s.getBoundingClientRect().width + (parseFloat(getComputedStyle(tr).columnGap) || 0) : 0;
  }
  function updateDots(tr) {
    var dots = tr.parentNode.querySelectorAll('.pc-feat-dot');
    if (!dots.length) return;
    var step = stepOf(tr);
    var idx = step ? Math.round(tr.scrollLeft / step) : 0;
    if (tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 2) idx = dots.length - 1;
    for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === idx);
  }
  var ticking = false;
  document.addEventListener('scroll', function (e) {
    var tr = e.target;
    if (!tr || !tr.hasAttribute || !tr.hasAttribute('data-pc-track') || ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; updateDots(tr); });
  }, { capture: true, passive: true });

  /* ---------- swipe fallback + mouse drag ---------- */
  function trackFrom(el) { return el && el.closest ? el.closest('[data-pc-track]') : null; }
  function snap(tr) {
    var step = stepOf(tr);
    if (!step) return;
    var max = tr.scrollWidth - tr.clientWidth;
    var target = Math.min(max, Math.max(0, Math.round(tr.scrollLeft / step) * step));
    tr.classList.remove('pc-dragging');
    tr.scrollTo({ left: target, behavior: 'smooth' });
  }
  var suppressClick = false;
  function blockNextClick() { suppressClick = true; setTimeout(function () { suppressClick = false; }, 350); }

  /* Touch: let the browser scroll natively; only if the strip does not move, scroll it ourselves */
  var drag = null;
  document.addEventListener('touchstart', function (e) {
    var tr = trackFrom(e.target);
    if (!tr || e.touches.length !== 1) { drag = null; return; }
    var p = e.touches[0];
    drag = { tr: tr, x: p.clientX, y: p.clientY, left: tr.scrollLeft, mode: null, manual: false };
  }, { capture: true, passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!drag || !e.touches.length) return;
    var p = e.touches[0];
    var dx = p.clientX - drag.x, dy = p.clientY - drag.y;
    if (!drag.mode) {
      if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
      drag.mode = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
    }
    if (drag.mode !== 'x') return;
    if (!drag.manual && Math.abs(dx) > 12 && Math.abs(drag.tr.scrollLeft - drag.left) < 1) {
      drag.manual = true;
      drag.tr.classList.add('pc-dragging');
    }
    if (drag.manual) {
      drag.tr.scrollLeft = drag.left - dx;
      if (e.cancelable) e.preventDefault();
    }
  }, { capture: true, passive: false });
  document.addEventListener('touchend', function () {
    if (drag && drag.manual) { snap(drag.tr); blockNextClick(); }
    drag = null;
  }, { capture: true, passive: true });
  document.addEventListener('touchcancel', function () {
    if (drag && drag.manual) snap(drag.tr);
    drag = null;
  }, { capture: true, passive: true });

  /* Mouse: click-and-drag to scroll (desktop testing, small laptop windows) */
  var md = null;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var tr = trackFrom(e.target);
    if (!tr) return;
    md = { tr: tr, x: e.clientX, left: tr.scrollLeft, moved: false };
  }, true);
  document.addEventListener('pointermove', function (e) {
    if (!md) return;
    var dx = e.clientX - md.x;
    if (!md.moved && Math.abs(dx) > 5) { md.moved = true; md.tr.classList.add('pc-dragging'); }
    if (md.moved) { md.tr.scrollLeft = md.left - dx; e.preventDefault(); }
  }, true);
  document.addEventListener('pointerup', function () {
    if (md && md.moved) { snap(md.tr); blockNextClick(); }
    md = null;
  }, true);
  document.addEventListener('click', function (e) {
    if (suppressClick && trackFrom(e.target)) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  document.addEventListener('dragstart', function (e) {
    if (trackFrom(e.target)) e.preventDefault();
  }, true);
})();